export const originalTheme = Object.freeze({
  context: {
    gradient: true,
    shadow: 'lg', // 3 states: 'sm', 'lg', undefined (no shadow).
    invertedColor: false,
    name: 'light',
  },
  colors: {
    primary: '#020045',
    secondary: '#FFFBFA',
    background: '#f6f7f6',
    success: '#3d9209',
    info: '#2c82e0',
    danger: '#ff0c00',
    warning: '#dc952a',
    white: '#ffffff',
    dark: '#262824',
    textColor: '#262824',
    gray: '#767c88',
  },
})

export const corporateTheme = Object.freeze({
  context: {
    gradient: true,
    shadow: 'sm',
    invertedColor: false,
    name: 'dark',
  },
  colors: {
    primary: '#FF00A4',
    secondary: '#271E24',
    background: '#170C16',
    success: '#3d9209',
    info: '#2c82e0',
    danger: '#ff0c00',
    warning: '#dc952a',
    white: '#262824',
    dark: '#000000',
    textColor: '#ffffff',
    gray: '#7d7d7d',
  },
})
